// Phase 10 — UserDashboardPage.
//
// Route-level wrapper for the 11-widget User Dashboard.

import { UserDashboard } from "../../modes/dashboard/UserDashboard.tsx";

export function UserDashboardPage(): JSX.Element {
  return <UserDashboard />;
}
